module.exports = __webpack_public_path__ + "img/hero8-loader.f34738d8.jpg";